import { render, staticRenderFns } from "./quoteDetailInfo.vue?vue&type=template&id=703529ef&scoped=true"
import script from "./quoteDetailInfo.vue?vue&type=script&lang=js"
export * from "./quoteDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./quoteDetailInfo.vue?vue&type=style&index=0&id=703529ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703529ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703529ef')) {
      api.createRecord('703529ef', component.options)
    } else {
      api.reload('703529ef', component.options)
    }
    module.hot.accept("./quoteDetailInfo.vue?vue&type=template&id=703529ef&scoped=true", function () {
      api.rerender('703529ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/components/quoteDetailInfo.vue"
export default component.exports